$.onmount('[data-component=bundle-sku-select]', function() {
  var $el = $(this)

  function bundleSkuLabel(item, escape) {
    var labels = []

    if (item.name) labels.push(item.name)
    if (item.sku) labels.push('SKU: ' + item.sku)
    if (item.barcode) labels.push('JAN: ' + item.barcode)

    return escape(labels.join(' / '))
  }

  function bundleSkuCode(label, value, escape) {
    if (!value) return ''

    return '<span class="bundle-sku-code">' + escape(label + value) + '</span>'
  }

  function onLoad(query, callback) {
    if (!query.length) return callback()

    $.ajax({
      url: '/products/search_products_to_select',
      dataType: 'JSON',
      data: { keyword: query },
      success: callback,
      error: callback
    })
  }

  $el.selectize({
    load: onLoad,
    valueField: 'sku',
    labelField: 'name',
    searchField: ['name', 'sku', 'barcode'],
    options: [],
    create: false,
    allowEmptyOption: true,
    placeholder: 'Search products by name or SKU..',
    render: {
      option: function(item, escape) {
        return '<div>' +
          '<span class="bundle-sku-name">' + escape(item.name) + '</span>' +
          bundleSkuCode('SKU: ', item.sku, escape) +
          bundleSkuCode('JAN: ', item.barcode, escape) +
          '</div>'
      },
      item: function(item, escape) {
        return '<div>' + bundleSkuLabel(item, escape) + '</div>'
      }
    }
  })
})
